import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';
import { Banner } from '../../Auth/Banner/Banner';
import { BannerShopify } from '../../Auth/Banner/BannerShopify';
import { QuickchatAiIcon } from '../../icons/uickchatAi.icon';

export default function EntryLayout() {
  const location = useLocation();
  const { page } = useAnalytics();

  useEffect(() => {
    page({
      path: location.pathname,
      search: location.search,
      url: window.location.origin + location.pathname + location.search + location.hash,
    });
  }, [location]);

  return (
    <div className="flex min-h-screen min-w-screen">
      <div
        className={`w-full ${location.search.includes('shopify') ? 'lg:w-[55%]' : ''} flex items-center justify-center`}
      >
        <div className="w-[450px]">
          <div className="px-11 pb-5 pt-11">
            <a href="https://quickchat.ai">
              <QuickchatAiIcon className="scale-100 absolute top-6 left-5" />
            </a>
            <Outlet />
            <small className="mt-7 text-center text-gray-500 block">
              © {new Date().getFullYear()} Incentivai Inc.
            </small>
          </div>
        </div>
      </div>
      <div
        className={`hidden ${location.search.includes('shopify') ? 'lg:flex' : ''} w-[45%] justify-end`}
      >
        {location.search.includes('shopify') ? <BannerShopify /> : <Banner />}
      </div>
    </div>
  );
}
